import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ShoppingBasketIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M14.45 1.17a1 1 0 0 1 1.38.28L19.53 7H21a2 2 0 0 1 2 2v2a2 2 0 0 1-1.03 1.75 1 1 0 0 1 .02.4l-1 6.93A3 3 0 0 1 18 23H6a3 3 0 0 1-3-2.92l-.99-6.94a1 1 0 0 1 .02-.39A2 2 0 0 1 1 11V9c0-1.1.9-2 2-2h1.46l3.7-5.55a1 1 0 0 1 1.67 1.1L6.87 7h10.26l-2.96-4.45a1 1 0 0 1 .28-1.38ZM4.98 9H21v2H3V9h1.98ZM20 13H4.01l.98 6.86L5 20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1l.01-.14.98-6.86Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ShoppingBasketIcon;
